const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopiedLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-915 -133)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(915 133)",
    style: {
      fill: "#0222ba"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "done_black_24dp (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 213",
    d: "M0 0h15.527v15.527H0z",
    style: {
      fill: "none"
    },
    transform: "translate(918.236 136.236)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 214",
    d: "M7.023 12.458 4.306 9.741l-.906.906 3.623 3.623 7.764-7.764-.906-.906z",
    transform: "translate(917.036 134.259)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopiedLight);
export default __webpack_public_path__ + "static/media/icon-copied-light.56f868858d75fe44c70d2bbeb18735ad.svg";
export { ForwardRef as ReactComponent };